module.exports = __webpack_public_path__ + "static/img/joyChat.721bc397.png";